import { Pipe } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TagsFormatService } from '../tags/tags-format.service';
import { isNil } from 'ramda/es';

const pattern: RegExp = /(\(!--[^\s-]*--\))/;

@Pipe({
  name: 'prettytags'
})
export class PrettyTagsPipe {
  constructor(private sanitizer: DomSanitizer, private tagFormat: TagsFormatService) {}

  transform(value: string, completions: any[]): SafeHtml {
    if (isNil(value)) return '';
    const formatFunction = this.tagFormat.getTagHtml.bind(this.tagFormat);
    const text = this.tagFormat.makeText(value, completions, formatFunction, 0);
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/tag-editor/tag-editor.pipe.ts